import axios from "axios";
import { getAccessToken, getRefreshTokenFromCookie, } from "@erp/shared/utils/auth/token";
import { handle500Error } from "./nest/_global/handle500Error";
import { handle401Error } from "./nest/_global/handle401Error";
import { handle400Error } from "./nest/_global/handle400Error";
import qs from "qs";
import { ZodError } from "zod";
import { movePage } from "../utils/router/movePage";
import { isAuthExpiredError } from "./_type/AuthErrorType";
let nestServer;
/**
 * @description axios 전역 인스턴스 생성하여서 당장은 필요 없지만, 나중에 사용할 수 있도록 설정
 * 필요없다고 생각되면 제거하여도 됨
 */
export const initNestServer = (baseURL) => {
    if (!baseURL) {
        console.error("Nest Server URL이 설정되지 않았습니다.");
    }
    nestServer = axios.create({ baseURL });
    nestServer.interceptors.request.use((config) => {
        if (config.url?.includes("/auth/login")) {
            return config;
        }
        else if (config.url?.includes("/auth/access/reissue")) {
            const refreshToken = getRefreshTokenFromCookie();
            if (refreshToken) {
                config.headers["Authorization"] = `Refresh ${refreshToken}`;
            }
            return config;
        }
        const token = getAccessToken();
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    nestServer.interceptors.response.use((response) => {
        return response;
    }, async (error) => {
        const originalConfig = error.config;
        const status = error.response?.status;
        // ZodError 처리 추가
        if (error instanceof ZodError) {
            console.warn("Zod 스키마 검증 실패:", error.issues);
        }
        // 원요청 정보가 없으면 네트워크 에러 — 호출부에서 처리
        if (!originalConfig || !error?.response) {
            return Promise.reject(error);
        }
        // 이미 재시도 했던 요청이면 더 이상 진행 안 함 (무한 루프 방지)
        if (originalConfig._retry) {
            return Promise.reject(error);
        }
        // 서버 응답 메시지 추출: userMessage에 저장
        const serverMessage = error.response?.data?.message;
        if (serverMessage && typeof serverMessage === "string") {
            error.userMessage = serverMessage;
        }
        const errorCode = error.response?.data?.code;
        if (errorCode && typeof errorCode === "string") {
            error.errorCode = errorCode;
        }
        if (status === 401) {
            try {
                return await handle401Error(error, originalConfig);
            }
            catch (e) {
                if (isAuthExpiredError(e)) {
                    movePage("/");
                    return;
                }
                return Promise.reject(e);
            }
        }
        else if (status === 400) {
            return await handle400Error(error, originalConfig);
        }
        else if (status === 500) {
            return await handle500Error(error, originalConfig);
        }
        // 기타 HTTP 에러 (403, 404, 409 등) — 호출부에서 처리
        return Promise.reject(error);
    });
    nestServer.defaults.paramsSerializer = (params) => qs.stringify(params, { arrayFormat: "repeat" });
    return nestServer;
};
// 하위 호환성을 위해 기본 export (초기화 전에는 사용 불가)
export { nestServer };
